import { useCallback, useEffect, useState } from "react";

import { skillService } from "../services/skillService";
import { useToast } from "../components/common/ToastContext";

export const useSkillsContext = () => {
  const { showToast } = useToast();
  const [skills, setSkills] = useState([]);
  const [coreSkills, setCoreSkills] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [selectedCoreSkillKey, setSelectedCoreSkillKey] = useState(selectedSkill?.overloads || null);

  const fetchSkills = useCallback(async () => {
    try {
      const fetchedSkills = await skillService.list();
      const sortedSkills = fetchedSkills.sort((a, b) =>
        a.key.localeCompare(b.key)
      );
      const skillsWithCore = sortedSkills.map((skill) => ({
        ...skill,
        isCore: skill.id.startsWith("core-"),
      }));
      const filteredCoreSkills = skillsWithCore.filter((skill) => skill.isCore);

      setSkills(skillsWithCore);
      setCoreSkills(filteredCoreSkills);
    } catch (error) {
      console.error("Error fetching skills:", error);
      showToast("Failed to fetch skills", "error");
    }
  }, [showToast]);

  useEffect(() => {
    fetchSkills();
  }, []);

  return {
    coreSkills,
    selectedCoreSkillKey,
    selectedSkill,
    skills,
    fetchSkills,
    setSelectedCoreSkillKey,
    setSelectedSkill,
    setSkills,
  };
};
